"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _utils = require("../../utils");

var _checkbox = require("./fields/checkbox");

var _date = require("./fields/date");

var _email = require("./fields/email");

var _number = require("./fields/number");

var _select = require("./fields/select");

var _text = require("./fields/text");

var _textArea = require("./fields/text-area");

var styles = _interopRequireWildcard(require("./field.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const getFieldProps = _ref => {
  let {
    error,
    submitted,
    label,
    required
  } = _ref;
  return {
    error,
    label,
    required,
    submitted
  };
};

const getInputProps = _ref2 => {
  let {
    error,
    submitted,
    ...inputProps
  } = _ref2;
  return inputProps;
};

const makePropTypes = propTypes => ({ ...(0, _utils.removeProperty)(Field.propTypes, "input"),
  ...propTypes
});

let FIELD_AUTO_ID = 0;

const Field = _ref3 => {
  let {
    label,
    input,
    error = null,
    required = false,
    submitted = false
  } = _ref3;
  const [touched, setTouched] = (0, _react.useState)(false);
  const id = (0, _react.useMemo)(() => "field-".concat(FIELD_AUTO_ID++), []);
  const wrapperClassName = (0, _react.useMemo)(() => [styles.wrapper, error ? styles.error : "", touched ? styles.touched : "", required ? styles.required : "", submitted ? styles.submitted : ""].join(" "), [error, required, touched, submitted]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/_react.default.createElement(input.type, _extends({}, input.props, {
    id: id,
    className: styles.input,
    "data-value": input.props.value || "",
    onBlur: () => setTouched(true)
  })), label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: styles.label
  }, /*#__PURE__*/_react.default.createElement(_.Text, {
    family: "f2",
    size: "s2",
    transform: "uppercase",
    className: styles.text
  }, label)), /*#__PURE__*/_react.default.createElement(_.Text, {
    size: "s1",
    className: styles.message
  }, error));
};

exports.Field = Field;
Field.propTypes = {
  input: _propTypes.default.element.isRequired,
  error: _propTypes.default.string,
  label: _propTypes.default.string,
  required: _propTypes.default.bool,
  submitted: _propTypes.default.bool
};

Field.Checkbox = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  label: "",
  input: /*#__PURE__*/_react.default.createElement(_checkbox.CheckboxField, getInputProps(props))
}));

Field.Checkbox.propTypes = makePropTypes(_checkbox.CheckboxField.PropTypes);

Field.Date = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_date.DateField, getInputProps(props))
}));

Field.Date.propTypes = makePropTypes(_date.DateField.PropTypes);

Field.Email = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_email.EmailField, getInputProps(props))
}));

Field.Email.propTypes = makePropTypes(_email.EmailField.PropTypes);

Field.Number = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_number.NumberField, getInputProps(props))
}));

Field.Number.propTypes = makePropTypes(_number.NumberField.PropTypes);

Field.Select = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_select.SelectField, getInputProps(props))
}));

Field.Select.propTypes = makePropTypes(_select.SelectField.PropTypes);

Field.Text = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_text.TextField, getInputProps(props))
}));

Field.Text.propTypes = makePropTypes(_text.TextField.PropTypes);

Field.TextArea = props => /*#__PURE__*/_react.default.createElement(Field, _extends({}, getFieldProps(props), {
  input: /*#__PURE__*/_react.default.createElement(_textArea.TextAreaField, getInputProps(props))
}));

Field.TextArea.propTypes = makePropTypes(_textArea.TextAreaField.PropTypes);